/**
 * @flow
 */

import React from 'react'
import Helmet from 'react-helmet'

class SEO extends React.Component {
  render() {
    const { SEOData } = this.props
    const {
      title,
      description,
      ogTitle,
      ogUrl,
      ogImage,
      ogDescription,
      ogSiteName,
      ogType,
      twitterTitle,
      twitterUrl,
      twitterDescription,
      twitterImage,
      twitterSite,
      schemaData,
      canonicalUrl,
      isRobotsTextEnabled
    } = SEOData
    return (
      <Helmet>
        {schemaData && (
          <script type="application/ld+json">{`${schemaData}`}</script>
        )}
        {title && <title>{title}</title>}
        {description && <meta name="description" content={description} />}
        {ogTitle && <meta property="og:title" content={ogTitle} />}
        {ogUrl && <meta property="og:url" content={ogUrl} />}
        {ogImage && <meta property="og:image" content={ogImage} />}
        {ogDescription && (
          <meta property="og:description" content={ogDescription} />
        )}
        {ogType && <meta property="og:type" content={ogType} />}
        {ogSiteName && <meta property="og:site_name" content={ogSiteName} />}
        {twitterTitle && (
          <meta property="twitter:title" content={twitterTitle} />
        )}
        {twitterUrl && <meta name="twitter:url" content={twitterUrl} />}
        {twitterSite && <meta name="twitter:site" content={twitterSite} />}
        {twitterDescription && (
          <meta property="twitter:description" content={twitterDescription} />
        )}
        {twitterImage && <meta name="twitter:image" content={twitterImage} />}
        {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
        {isRobotsTextEnabled && <meta name="robots" content="noindex" />}
      </Helmet>
    )
  }
}

export default SEO



// WEBPACK FOOTER //
// ./src/components/core/SEO/index.js